import { lazy } from 'react';

export const ADPProfilePage = lazy(() => import('./ADPProfilePage'));
